import { render, staticRenderFns } from "./EditStoreProduct.vue?vue&type=template&id=edc631ae&scoped=true"
import script from "./EditStoreProduct.vue?vue&type=script&lang=js"
export * from "./EditStoreProduct.vue?vue&type=script&lang=js"
import style0 from "./EditStoreProduct.vue?vue&type=style&index=0&id=edc631ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc631ae",
  null
  
)

export default component.exports